import { render, staticRenderFns } from "./Backend.vue?vue&type=template&id=5e16548f&scoped=true"
import script from "./Backend.vue?vue&type=script&lang=js"
export * from "./Backend.vue?vue&type=script&lang=js"
import style0 from "./Backend.vue?vue&type=style&index=0&id=5e16548f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e16548f",
  null
  
)

export default component.exports